<!-- 套餐修改 -->
<template>
  <div class="apply" v-loading="loading">
    <back />
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
      <div class="form">
        <div class="title">基本信息:</div>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item class="item logo_pic" label="套餐图片：" prop="picUrl1">
              <div class="pic-row">
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess1" :before-upload="beforeUploads" :on-remove="handleRemoveLogo1" :disabled="ruleForm.picUrl1 ? true : false">
                    <img v-if="ruleForm.picUrl1" :src="ruleForm.picUrl1" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl1" class="delpic delpic1 el-icon-error" @click="handleRemoveLogo1"></i>
                </div>
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess2" :before-upload="beforeUploads" :on-remove="handleRemoveLogo2" :disabled="ruleForm.picUrl2 ? true : false">
                    <img v-if="ruleForm.picUrl2" :src="ruleForm.picUrl2" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl2" class="delpic delpic2 el-icon-error" @click="handleRemoveLogo2"></i>
                </div>
                <div class="pic">
                  <el-upload class="logo_uploader" accept=".png,.jpeg,.jpg" name="multipartFile" :action="action" :show-file-list="false" :on-success="handleSuccess3" :before-upload="beforeUploads" :on-remove="handleRemoveLogo3" :disabled="ruleForm.picUrl3 ? true : false">
                    <img v-if="ruleForm.picUrl3" :src="ruleForm.picUrl3" class="logoimg">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <i v-if="ruleForm.picUrl3" class="delpic delpic3 el-icon-error" @click="handleRemoveLogo3"></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="dialog_row">
          <el-col :span="8">
            <el-form-item class="item" label="项目套餐名称:" prop="packageName">
              <el-input v-model="ruleForm.packageName" placeholder="请输入项目套餐名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="原价(元):" prop="originalPrice">
              <el-input v-model="ruleForm.originalPrice" placeholder="自动计算原价(元)" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="item" label="套餐价(元):" prop="discountPrice">
              <el-input v-model="ruleForm.discountPrice" placeholder="自动计算套餐价(元)" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="display: flex; justify-content: space-between;align-items: center;">
          <div class="title">套餐项目:</div>
          <!-- 按钮 -->
          <el-button type="primary" @click="onAdd">加入项目</el-button>
        </div>
        <div class="g_table" style="margin-bottom: 20px; overflow: auto">
          <el-table :data="dataList" max-height="540">
            <el-table-column label="序号" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="categoryName" label="分类"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="durationMinute" label="服务时长(min)">
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionRate" label="提成比例(%)">
              <template slot-scope="scope">
                {{ scope.row.commissionRate ? scope.row.commissionRate : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionAmount" label="提成金额(元)">
              <template slot-scope="scope">
                {{ scope.row.commissionAmount ? scope.row.commissionAmount : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="80" show-overflow-tooltip prop="projectCount" label="次数"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="originalPrice" label="原售价(元)"></el-table-column>
            <el-table-column min-width="120" show-overflow-tooltip prop="discountPrice" label="优惠价(元)" align="center">
              <template slot-scope="scope">
                <!-- 输入框 -->
                <el-input v-model="scope.row.discountPrice" placeholder="请输入优惠价(元)" @change="handleBox(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="150px" fixed="right">
              <template slot-scope="scope">
                <el-button type="danger" plain @click="handleDel(scope.$index,scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="submit-btn">
        <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button type="primary" plain @click="$router.go(-1)">取消</el-button>
      </div>
    </el-form>
    <el-dialog title="加入项目" :visible.sync="dialogShow" :before-close="()=>{dialogShow=false}" width="70%">
      <el-form ref="newData1" label-width="180px" class="demo-ruleForm">
        <div style="display: flex;justify-content: flex-end; margin-bottom: 20px;">
          <el-cascader collapse-tags v-model="categoryValue" :options="optionArry" placeholder="项目分类" :props="{ expandTrigger: 'hover', label: 'categoryName', value: 'categoryId', children: 'children', emitPath: false, checkStrictly: false,multiple:true }" @change="onSearch" clearable></el-cascader>
          <el-input class="s_input" v-model="projectName" placeholder="请搜索项目名称" suffix-icon="el-icon-search" @change="onSearch" clearable style="margin-left: 20px;"></el-input>
        </div>
        <div class="g_table" style="margin-bottom: 20px; overflow: auto">
          <el-table :data="tableData" max-height="540" :row-key="row => row.projectId" @selection-change="handleSelectionChange" ref="multipleTable">
            <el-table-column type="selection" width="55" fixed="left" :reserve-selection="true"></el-table-column>
            <el-table-column label="序号" show-overflow-tooltip width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
            <el-table-column min-width="150" show-overflow-tooltip prop="categoryName" label="分类"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="price" label="定价(元)"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="linePrice" label="划线价(元)"></el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="durationMinute" label="服务时长(min)">
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionRate" label="员工提成比例(%)">
              <template slot-scope="scope">
                {{ scope.row.commissionRate ? scope.row.commissionRate : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="100" show-overflow-tooltip prop="commissionAmount" label="员工提成金额(元)">
              <template slot-scope="scope">
                {{ scope.row.commissionAmount ? scope.row.commissionAmount : '——' }}
              </template>
            </el-table-column>
            <el-table-column min-width="80" show-overflow-tooltip prop="projectCount" label="次数"></el-table-column>
          </el-table>
        </div>

      </el-form>
      <el-pagination class="pg_input" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
      <span slot="footer">
        <el-button type="primary" @click="addData1">确 定</el-button>
        <el-button @click="dialogShow=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>



export default {

  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的行数
      pageSizeArr: [5, 10, 20], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      categoryValue: "",
      projectName: "",
      tableData: [],
      dataList: [],
      dialogShow: false,
      loading: false,
      ruleForm: {
        packageName: '',//套餐名称
        originalPrice: '', // 原价
        discountPrice: '', // 套餐价
        picUrl1: "", //商品图片
        picUrl2: "", //商品图片
        picUrl3: "", //商品图片
      },

      rules: {
        packageName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' },
        ],
        picUrl1: [
          { required: true, message: '请上传图片', trigger: 'blur' },
        ],
      },

      // 图片上传
      fileList: [],
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      inputValue: '',
      add: null,
      multipleSelection: [],
      optionArry: [],
    }
  },
  created() {
    this.getDataList()


  },

  methods: {
    // 详情
    getDataList() {
      this.loading = true;
      this.$axios.get(this.$api.selectProjectPackageDetail, {
        params: {
          id: this.$route.query.id
        }
      }).then(res => {
        this.ruleForm = res.result
        this.dataList = res.result.infoVoList
        if (this.ruleForm.urlList && Array.isArray(this.ruleForm.urlList)) {
          this.$set(this.ruleForm, 'picUrl1', this.ruleForm.urlList[0] || '');
          this.$set(this.ruleForm, 'picUrl2', this.ruleForm.urlList[1] || '');
          this.$set(this.ruleForm, 'picUrl3', this.ruleForm.urlList[2] || '');
        } else {
          this.$set(this.ruleForm, 'picUrl1', '');
          this.$set(this.ruleForm, 'picUrl2', '');
          this.$set(this.ruleForm, 'picUrl3', '');
        }
        this.dataList = this.dataList.map(item => {
          return {
            ...item,
            initialValue: item.originalPrice
          }
        })
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.desc)
      });
    },

    // 勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // multipleSelection 添加个price字段
      this.multipleSelection = this.multipleSelection.map(item => {
        return {
          ...item,
          originalPrice: item.price,
          discountPrice: item.price,
          initialValue: item.price
        }
      })
    },
    // 加入项目
    addData1() {
      // 判断dataList添加的数据，过滤重复数据
      let dataList = this.dataList.filter(item => {
        return !this.multipleSelection.some(item1 => item1.projectId === item.projectId)
      })
      dataList = dataList.concat(this.multipleSelection)
      this.dataList = dataList
      this.handlePrice()
      this.handleDiscountPrice()
      this.$refs.multipleTable.clearSelection();
      this.dialogShow = false
    },
    // 计算原价
    handlePrice() {
      let totalLinePrice = 0;
      for (let i = 0; i < this.dataList.length; i++) {
        totalLinePrice += this.dataList[i].originalPrice
      }
      this.ruleForm.originalPrice = totalLinePrice.toFixed(2)

    },
    // 计算套餐价
    handleDiscountPrice() {
      // dataList数组中的preferential总和计算
      let preferentialPrice = 0;
      for (let i = 0; i < this.dataList.length; i++) {
        preferentialPrice += Number(this.dataList[i].discountPrice)
      }
      this.ruleForm.discountPrice = preferentialPrice.toFixed(2)
    },

    handleBox(row) {
      const regex = /^\d+(?:\.\d{0,2})?$/;
      let boolean = regex.test(Number(row.discountPrice))
      // let boolean = new RegExp(/^[0-9]+(\.[0-9]{1,2})?$/).test(Number(row.discountPrice))
      // let boolean = new RegExp("^[0-9][0-9]*$").test(Number(row.discountPrice))

      if ((Number(row.discountPrice) > Number(row.originalPrice)) || !boolean || row.discountPrice == "") {
        this.$message.warning("只能输入数字保留两位小数，优惠价不能为空且不可以大于原售价")
        row.discountPrice = Number(row.initialValue)
        return
      }
      this.handleDiscountPrice()
    },
    // 删除
    handleDel(index, row) {
      this.dataList.splice(index, 1)
      this.handlePrice()
      this.handleDiscountPrice()
    },
    // 打开弹框
    onAdd() {
      this.dialogShow = true
      this.getShopProductList()
      this.getCategoryInfoList()

    },

    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getShopProductList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getShopProductList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getShopProductList()
    },
    // 分类
    getCategoryInfoList() {
      this.$axios
        .get(this.$api.projectList, {
          params: {
            page: 1,
            pageSize: 9999,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.optionArry = res.result.list
            this.optionArry.map(item => {
              if (item.children.length == 0) {
                item.children = null
              }
            })
          }
          // this.loading = false
        })
    },

    // 获取项目列表
    getShopProductList() {
      this.loading = true
      this.$axios.post(this.$api.selectProjectInfoList, {
        categoryIdList: this.categoryValue || [], // 请搜索分类
        projectName: this.projectName || null, // 搜索项目名称
        page: this.currentPage,
        pageSize: this.pageSize,
        projectType: 1,
      })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch((err) => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 表单校验
    submitForm(formName) {
      console.log(this.dataList);

      const productList = this.dataList.map(item => {
        return {
          discountPrice: item.discountPrice,
          originalPrice: item.originalPrice,
          projectCount: item.projectCount,
          projectId: item.projectId,
        }
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post(this.$api.updateProjectPackage, {
            itemDtoList: productList,
            id: this.ruleForm.id,
            originalPrice: this.ruleForm.originalPrice,
            discountPrice: this.ruleForm.discountPrice,
            packageName: this.ruleForm.packageName,
            urlList: [this.ruleForm.picUrl1 || null, this.ruleForm.picUrl2 || null, this.ruleForm.picUrl3 || null],
          }).then((res) => {
            if (res.code == 100) {
              this.$message.success(res.desc);
              this.$router.push('/formalProject/projectSetMenu');
              this.resetForm();
            }
          }).catch((res) => {
            this.$message.error(res.desc);
          })

        } else {
          this.$message.error("提交失败，某一条必填项未输入");

          return false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.ruleForm = {};
      this.$refs.ruleForm.resetFields();
      this.ruleForm.introduction = '';
    },
    handleRemoveLogo1() {
      this.ruleForm.picUrl1 = ""
    },
    handleSuccess1(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl1 = res.result.fileUrl;

      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo2() {
      this.ruleForm.picUrl2 = ""
    },
    handleSuccess2(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl2 = res.result.fileUrl;

      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    handleRemoveLogo3() {
      this.ruleForm.picUrl3 = ""
    },
    handleSuccess3(res) {
      if (res.code == 100) {
        this.ruleForm.picUrl3 = res.result.fileUrl;

      } else {
        this.$message({
          showClose: true,
          message: res.desc,
          type: "error",
        });
      }
    },
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },

    validatePrice(rule, value, callback) {
      const reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(value)) {
        callback(new Error(`必须为数字且最多保留两位小数`));
      } else {
        callback();
      }
    }
  },

}
</script>

<style lang="scss" scoped>
.apply {
  // 1.基本信息
  .form {
    margin: 30px 20px;

    .title {
      font-size: 20px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    ::v-deep .el-cascader {
      width: 367px;
    }
  }

  // 保质期天数
  .day {
    ::v-deep .el-form-item__label {
      color: #606266;
      font-size: 16px;
      padding-right: 30px;
    }

    ::v-deep.el-input__inner {
      background: #ffffff !important;
      border-radius: 10px 0 0 10px;
      border: none;
    }

    ::v-deep .el-input-group__append {
      background: #ffffff !important;
      border-radius: 0px 10px 10px 0;
      border: none;
      font-size: 20px;
      color: #606266;
    }
  }

  .submit-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 30px;
  }

  // 图片
  .logo_pic {
    position: relative;

    ::v-deep .el-form-item__content {
      width: 100px;
      height: 100px;
    }

    .pic-row {
      display: flex;

      .pic {
        margin-right: 15px;

        .logo_uploader {
          ::v-deep .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          ::v-deep .el-upload:hover {
            border-color: #069bbc;
          }

          .avatar-uploader-icon {
            font-size: 28px;
            color: #069bbc;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }

          .logoimg {
            width: 100px;
            height: 100px;
            display: block;
            object-fit: cover;
          }
        }
      }
    }

    .delpic {
      position: absolute;
      top: -12px;
      color: red;
      font-size: 20px;
      cursor: pointer;
    }

    .delpic1 {
      right: -15px;
    }

    .delpic2 {
      right: -134px;
    }

    .delpic3 {
      right: -250px;
    }
  }
}

// common
.dialog_row {
  .btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  // width: 850px;
  ::v-deep.el-form-item {
    margin-right: 100px;
  }

  ::v-deep.el-form-item__label {
    color: #272727;
    font-size: 16px;
    padding-right: 30px;
  }
}

/* input number类型取消增减箭头*/
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

// 光标上移
::v-deep.el-input__inner {
  line-height: 1px !important;
}

::v-deep .ql-editor {
  min-height: 200px;
  max-height: 500px;
}
</style>
